import { defineComponent as _defineComponent } from 'vue'
import '@/scss/material/layout/select-role-dialog.scss';

import { computed, onMounted, ref, watch } from 'vue';
import { CompanyUserStatusAction } from '@/@types/enums/CompanyUserStatusAction';
import { CombinedIdentity } from '@/@types/CombinedIdentity';
import { Workspace } from '@/models/Workspace';
import { Company } from '@/models/Company';
import { User } from '@/models/User';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectRoleDialog',
  props: {
    visible: { type: Boolean },
    value: null,
    mode: null,
    title: { default: 'Select role' },
    item: null,
    user: null,
    userStatusAction: { default: '' },
    isRemoveItem: { type: Boolean, default: true },
    canRecoverAccount: { type: Boolean, default: false }
  },
  emits: ["select", "removeItem", "changeStatus", "recoverAccount", "update:visible"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select', role: string, item: CombinedIdentity): CombinedIdentity;
  (e: 'removeItem', item: CombinedIdentity): CombinedIdentity;
  (e: 'changeStatus', item: CombinedIdentity): CombinedIdentity;
  (e: 'recoverAccount', item: CombinedIdentity): CombinedIdentity;
  (e: 'update:visible', value: boolean): boolean;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible?: boolean, value: string, mode: string, title: string, item: CombinedIdentity, user?: User, userStatusAction: string, isRemoveItem: boolean, canRecoverAccount: boolean }





const mdRoleSelect = ref<any>();

const roles = ref<{ [key: string]: string }>({});
const selected = ref<string | null>(null);
const showDialog = ref(false);

const getUserStatusActions = computed(() => CompanyUserStatusAction);

const isOwnRole = (role: string): boolean => props.item.id === props.user.id && props.item.role === role;

const getRoleHierarchy = (): { [key: string]: number } => {
  if (props.mode === 'workspace') {
    return {
      admin: 3,
      editor: 2,
      viewer: 1,
    };
  } else {
    // company mode
    return {
      owner: 4,
      admin: 3,
      moderator: 2,
      user: 1,
    };
  }
};

const isRoleDisabled = (roleKey: string | number): boolean => {
  if (!props.user || !props.user.role) return false;

  const hierarchy = getRoleHierarchy();
  const currentUserRoleLevel = hierarchy[props.user.role] || 0;
  const targetUserRoleLevel = hierarchy[props.item.role] || 0;
  const targetRoleLevel = hierarchy[String(roleKey)] || 0;

  // Disable if trying to modify a user with role >= your own
  if (targetUserRoleLevel >= currentUserRoleLevel) return true;

  // Disable if target role level is higher or equal to current user's role level
  return targetRoleLevel >= currentUserRoleLevel;
};

const canModifyTargetUser = (): boolean => {
  if (props.mode === 'workspace') return true;
  if (!props.user || !props.user.role) return false;

  const hierarchy = getRoleHierarchy();
  const currentUserRoleLevel = hierarchy[props.user.role] || 0;
  const targetUserRoleLevel = hierarchy[props.item.role] || 0;

  // Can modify if current user's role level is strictly higher than target user's role level
  return currentUserRoleLevel > targetUserRoleLevel;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const show = () => (showDialog.value = true);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const close = () => {
  emit('update:visible', false);
  showDialog.value = false;
};

const handleSelect = (item: CombinedIdentity) => emit('select', selected.value, item);

const handleRemoveItem = (item: CombinedIdentity) => emit('removeItem', item);

const handleChangeStatusItem = (item: CombinedIdentity) => {
  emit('changeStatus', item);
  mdRoleSelect.value.showSelect = false;
};

const handleRecoverAccountItem = (item: CombinedIdentity) => {
  emit('recoverAccount', item);
  mdRoleSelect.value.showSelect = false;
};

const updateRolesList = () => {
  switch (props.mode) {
    case 'workspace': {
      roles.value = Workspace.getRolesList();
      break;
    }
    case 'company':
    default: {
      roles.value = Company.getRolesList();
    }
  }
};

onMounted(() => {
  selected.value = props.value;
  updateRolesList();
});

watch(
  () => props.value,
  () => {
    selected.value = props.value;
  }
);

watch(
  () => props.mode,
  () => {
    updateRolesList();
  }
);

return { __sfc: true,props, emit, mdRoleSelect, roles, selected, showDialog, getUserStatusActions, isOwnRole, getRoleHierarchy, isRoleDisabled, canModifyTargetUser, show, close, handleSelect, handleRemoveItem, handleChangeStatusItem, handleRecoverAccountItem, updateRolesList }
}

})